import React, { useState, useCallback, useEffect } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

import {
  DashboardContainer,
  SideContent,
} from './dashboard.styles';

import Navigation from './components/navigation/navigation.component';
import Widgets from './components/widgets/widgets.component';
import MainContent from './components/main/main-content.component';
import NewPostDialog from '../../components/post/new-post-dialog.component';
import CreateWorkoutPost from '../../components/post/create-workout-post.component';
import CreateMealPost from '../../components/post/create-meal-post.component';
import CreateProgressPost from '../../components/post/create-progress-post.component';
import BottomNavigationBar from '../../components/bottom-navigation/bottom-navigation.component';
import { AchievementPopup } from '../../components/achievements/achievement-popup.component';
import { DemoBanner } from '../../components/demo-banner/demo-banner.component';
import { useAccountability } from '../../context/accountability.context';
import { useAuth } from '../../context/auth.context';

const Dashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const { isDemo } = useAuth();
  const { unseenAchievements, handleDismissAchievement } = useAccountability();
  const [currentPopup, setCurrentPopup] = useState(null);

  // Show unseen achievements one at a time
  useEffect(() => {
    if (unseenAchievements.length > 0 && !currentPopup) {
      setCurrentPopup(unseenAchievements[0]);
    }
  }, [unseenAchievements, currentPopup]);

  const handleDismissPopup = useCallback(() => {
    if (currentPopup) {
      handleDismissAchievement(currentPopup.id);
      setCurrentPopup(null);
    }
  }, [currentPopup, handleDismissAchievement]);

  return (
    <>
      {/* Skip to main content link for accessibility */}
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      {isDemo && <DemoBanner />}
      <DashboardContainer>
        {/* Sidebar navigation: hidden on mobile (replaced by bottom nav) */}
        {!isMobile && <Navigation />}
        <MainContent />
        {/* Widgets sidebar: visible only on desktop */}
        {isDesktop && (
          <SideContent>
            <Widgets />
          </SideContent>
        )}
      </DashboardContainer>
      {/* Post creation dialogs */}
      <NewPostDialog />
      <CreateWorkoutPost />
      <CreateMealPost />
      <CreateProgressPost />
      {/* Mobile bottom navigation */}
      {isMobile && <BottomNavigationBar />}
      {/* Achievement unlock popup */}
      <AchievementPopup
        achievement={currentPopup}
        onDismiss={handleDismissPopup}
      />
    </>
  );
};

export default Dashboard;
